module.exports = __webpack_public_path__ + "static/OurLocation-454529c2d914342842aa28f89ea12cbb.png";